import { render, staticRenderFns } from "./AutocompleteICD10.vue?vue&type=template&id=1b8ee8a3&scoped=true"
import script from "./AutocompleteICD10.vue?vue&type=script&lang=js"
export * from "./AutocompleteICD10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ee8a3",
  null
  
)

export default component.exports